var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05307 10.1331C2.82064 9.95459 2.77084 9.65991 2.89535 9.29468L3.72543 6.8335L1.61288 5.32275C1.2933 5.09448 1.15219 4.82886 1.24765 4.54248C1.34311 4.26855 1.60873 4.13159 1.99887 4.13574L4.58871 4.15649L5.37729 1.68286C5.49765 1.30518 5.70102 1.09351 5.99984 1.09351C6.29452 1.09351 6.49789 1.30518 6.61825 1.68286L7.40683 4.15649L9.99252 4.13574C10.3868 4.13159 10.6524 4.26855 10.7479 4.54663C10.8433 4.82886 10.7022 5.09448 10.3827 5.32275L8.27011 6.8335L9.10019 9.29468C9.2247 9.65991 9.17489 9.95459 8.94247 10.1331C8.7059 10.3157 8.41122 10.2576 8.08749 10.0251L5.99984 8.48535L3.9039 10.0251C3.58432 10.2576 3.28964 10.3157 3.05307 10.1331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.61ff9d91866d986abcec540448dbf948.svg";
export { ForwardRef as ReactComponent };